<template>
  <h1>Produktlager</h1>
  <div v-if="isIntern">
    <div
      v-for="product in products()"
      :key="product.productId">
      <ul
          class="list mb-0"
          v-if="productTotal(product.productId, false) !== false">
        <li class="row">
          <label class="col-5">
            {{ product.name }}
          </label>
          <div class="col-3 text-right">
            <span class="bold">{{ productTotal(product.productId, true) }} t</span><br/>
            E {{ productIncoming(product.productId, true) }} / A {{ productLoading(product.productId, true) }} t
          </div>
        </li>
      </ul>
    </div>
    <div class="row mb-3">
      <div class="col-5 bold">Gesamt</div>
      <div class="col-3 bold text-right">{{ productsTotal() }} t</div>
    </div>


    <h1 v-if="vesselsInStock" class="mt-5">BigBags</h1>
    <div
        v-for="regrater in regraters()"
        :key="regrater.contactId">
      <div
          v-if="regraterTotal(regrater.contactId, false) > 0">
        <h2>{{ regrater.name }}</h2>
        <ul class="subnav mb-0">
          <router-link
              v-for="vessel in getVesselsByRegrater(regrater.contactId)"
              :key="vessel.vesselId"
              :to="{name: 'BatchShow', params: {id: vessel.uniqueNumber}}">
            <li class="row">
              <label class="col-5">
                {{ vessel.number ? 'C '+ vessel.number : vessel.uniqueNumber }} {{ vessel.supplier }}
                <span v-if="getVesselChilds(vessel.vesselId)"><br/>{{ getVesselChildsText(vessel) }}</span>
                <span v-if="parseInt(vessel.parent_vesselId) > 0"><br/>{{ parseNumber(vessel.weight) }} kg &rarr; {{ getVesselsParentText(vessel) }}</span>
                <span v-if="vessel.stockLocation"><br/>Lager {{ vessel.stockLocation }}</span>
              </label>
              <div class="col-2 text-right">{{ getVesselWeight(vessel) }}</div>
              <div class="col-1"></div>
            </li>
          </router-link>
        </ul>
        <div class="row mb-3">
          <div class="col-5 bold">Summe</div>
          <div class="col-2 bold text-right">{{ regraterTotal(regrater.contactId) }} kg</div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
        v-for="supplier in suppliers()"
        :key="supplier.contactId">
      <div
          v-if="supplierTotal(supplier.contactId, false) > 0">
        <h2>{{ supplier.name }}</h2>
        <ul class="subnav mb-0">
          <router-link
              v-for="vessel in getVesselsBySupplier(supplier.contactId)"
              :key="vessel.vesselId"
              :to="{name: 'BatchShow', params: {id: vessel.uniqueNumber}}">
            <li class="row">
              <label class="col-3">{{ vessel.uniqueNumber }}
                <span v-if="getVesselChilds(vessel.vesselId)"><br/>{{ getVesselChildsText(vessel) }}</span>
                <span v-if="parseInt(vessel.parent_vesselId) > 0"><br/>{{ parseNumber(vessel.weight) }} kg &rarr; {{ getVesselsParentText(vessel) }}</span>
              </label>
              <div class="col-2 text-right">{{ getVesselWeight(vessel) }}</div>
              <div class="col-3"></div>
            </li>
          </router-link>
        </ul>
        <div class="row mb-3">
          <div class="col-3 bold">Summe</div>
          <div class="col-2 bold text-right">{{ supplierTotal(supplier.contactId) }} kg</div>
        </div>
      </div>
    </div>
  </div>

  <app-btn-back class="pt-2"/>
</template>

<script>

export default {
  name: "ProductStockPage",
  data() {
    return {
      productStock: null,
    }
  },
  async created() {
    this.$store.state.vessel = []
    await this.$store.dispatch('getItemList', {entityName: 'vessel', method: 'dried'})
    await this.$store.dispatch('initItems', {entityName: 'supplier'})
    await this.$store.dispatch('initItems', {entityName:'product'})

    this.$store.state.batch = []
    this.productStock = await this.$store.dispatch('getItemList', {entityName: 'batch', method: 'productsstored', returnData: true})

    if (this.isIntern)
      await this.$store.dispatch('initItems', {entityName: 'regrater'})
  },
  computed: {
    isIntern() {
      return this.$store.getters.isIntern
    },
    vesselsInStock() {
      return this.$store.state.vessel.length > 0
    }
  },
  methods: {
    products() {
      return this.$store.state.product
    },
    suppliers() {
      return this.$store.state.supplier
    },
    regraters() {
      return this.$store.state.regrater
      // return this.$store.state.batch.filter(batch => batch.washedWeight === null)
    },
    batches() {
      if (this.$store.state.batch)
        return this.$store.state.batch
        // return this.$store.state.batch.sort((a, b) => (a.incomingStockLocation || '').localeCompare(b.incomingStockLocation || ''))
      else
        return []
    },
    getVesselsByRegrater(contactId) {
      return this.$store.state.vessel.filter(vessel => vessel.regraterId == contactId)
    },
    productTotal(productId, formatted) {
      let total = 0
      const data = this.productStock ?? []
      const product = data.find(item => item.productId == productId)

      if (product)
        total += parseFloat(product.incomingWeight) - parseFloat(product.loadingWeight)
      else
        return false

      // in tons
      total /= 1000

      if (formatted === false)
        return total

      return this.parseNumber(total)
    },
    productIncoming(productId, formatted) {
      let total = 0
      const data = this.productStock ?? []
      const product = data.find(item => item.productId == productId)

      if (product)
        total += parseFloat(product.incomingWeight)

      // in tons
      total /= 1000

      if (formatted === false)
        return total

      return this.parseNumber(total)
    },
    productLoading(productId, formatted) {
      let total = 0
      const data = this.productStock ?? []
      const product = data.find(item => item.productId == productId)

      if (product)
        total += parseFloat(product.loadingWeight)

      // in tons
      total /= 1000

      if (formatted === false)
        return total

      return this.parseNumber(total)
    },
    productsTotal() {
      let total = 0
      const data = this.productStock ?? []
      total = data.map(item => {
        return parseFloat(item.incomingWeight) - parseFloat(item.loadingWeight)
      }).reduce((a, b) => a + b, 0)

      // in tons
      total /= 1000

      return this.parseNumber(total)
    },
    getProduct(productId) {
      const data = this.productStock ?? {}
      return data.find(item => item.productId == productId)
    },
    regraterTotal(contactId, formatted) {
      const vessels = this.getVesselsByRegrater(contactId)
      let total = 0

      for (let idx in vessels) {
        total += parseFloat(vessels[idx]['weight'])
      }
      if (formatted === false)
        return total

      return this.parseNumber(total)
    },
    getVesselsBySupplier(contactId) {
      return this.$store.state.vessel.filter(vessel => vessel.supplierId == contactId)
    },
    supplierTotal(contactId, formatted) {
      // console.log('suptotal',this.$store.state.vessel)
      // console.log(this.$store.state.supplier)
      const vessels = this.getVesselsBySupplier(contactId)
      let total = 0

      for (let idx in vessels) {
        total += parseFloat(vessels[idx]['weight'])
      }
      if (formatted === false)
        return total

      return this.parseNumber(total)
    },
    formattedInt(number) {
      return parseInt(number).toLocaleString('de-DE')
    },
    getVesselWeight(vessel) {
      let weight = parseFloat(vessel.weight)

      if (parseInt(vessel.parent_vesselId) > 0)
        return ''

      const childs = this.getVesselChilds(vessel.vesselId)
      if (childs) {
        for (const child of childs) {
          weight += parseFloat(child.weight)
        }
      }

      return this.parseNumber(weight) + ' kg'
    },
    getVesselChilds(vesselId) {
      const childs = this.$store.state.vessel.filter(vessel => vessel.parent_vesselId == vesselId)

      if (childs.length > 0)
        return childs

      return null
    },
    getVesselChildsText(vessel) {
      let texts = [
        vessel.uniqueNumber + ' ' + parseFloat(vessel.weight) + ' kg'
      ]
      const childs = this.getVesselChilds(vessel.vesselId)

      for (const child of childs) {
        texts.push(child['uniqueNumber'] + ' ' + parseFloat(child.weight) + ' kg')
      }

      return texts.join(', ')
    },
    getVesselsParentText(vessel) {
      const parent = this.$store.state.vessel.filter(entry => entry.vesselId === vessel.parent_vesselId)

      if (parent.length)
        return parent[0]['uniqueNumber']

      return ''
    },
    parseNumber(number, decimals = 1) {
      if (parseInt(number) != number)
        number = parseFloat(number)
      else
        number = parseInt(number)
      //return number
      return number.toLocaleString('de-DE', {minimumFractionDigits: decimals, maximumFractionDigits: decimals})
    },
    getSupplier(id) {
      if (!id || !this.$store.state.supplier) return ''
      const item = this.$store.state.supplier.find(item => item.contactId === id)
      if (!item) return ''
      return item.name
    },
    getRegrater(id) {
      if (!id || !this.$store.state.regrater) return ''
      const item = this.$store.state.regrater.find(item => item.contactId === id)
      if (!item) return ''
      return item.name
    },
  }
}
</script>

<style scoped>
h2 {
  padding-top: 0.5rem;
}

.subnav li:after {
  margin-left: -16px;
}
</style>